import React, { Fragment} from 'react';

import { memoryTypes } from '../../helpers/memory';

interface MemoryTypeSelectProps {
  variant?: 'memory' | 'timeline';
  selectedType: string;
  register: Function;
};

const MemoryTypeSelect: React.FC<MemoryTypeSelectProps> = ({ variant = 'memory', selectedType, register }) => {
  return (
    <div className={`memory-type-select-container inner ${variant}`}>
      <div className="memory-type-select-header">
        <div className="page-eyebrow">
          {variant === 'memory' ? (
            'What kind of memory is this?'
          ) : (
            'What kind of timeline is this?'
          )}
        </div>
      </div>
      <div className="memory-type-select">
        {memoryTypes.map((memoryType) => (
          <label key={memoryType.value}>
            <input
              type="radio"
              value={memoryType.value}
              defaultChecked={selectedType === memoryType.value}
              {...register('type')}
            />
            <div>
              <i className={`fa-solid fa-${memoryType.icon}`} />
              {memoryType.label}
            </div>
          </label>
        ))}
      </div>
      <div className="memory-type-descriptions">
        {memoryTypes.map((memoryType) => (
          <Fragment key={memoryType.value}>
            {selectedType === memoryType.value && (
              <wa-callout variant="neutral" className="memory-type-description">
                {memoryType.description}
              </wa-callout>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
}

export default MemoryTypeSelect;
